import axios from 'axios';
import Cookies from 'js-cookie';
import { API } from '../../../config/api';

export const offlineRequest = async (appId, suffix = '', options = {}) => {
  if (!appId || ['null', 'undefined'].includes(String(appId).trim())) throw new Error('Select a workspace before loading CRM data.');
  const { data } = await axios({
    url: `${API.offlineProspects}/${encodeURIComponent(appId)}${suffix}`,
    method: options.method || 'get', data: options.data, timeout: 20000,
    headers: { Authorization: `Bearer ${Cookies.get('token') || ''}`, ...(options.key ? { 'Idempotency-Key': options.key } : {}) },
  });
  return data.data;
};
export const submissionKey = () => window.crypto?.randomUUID ? window.crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
  const value = Math.floor(Math.random() * 16);
  return (char === 'x' ? value : (value % 4) + 8).toString(16);
});
export const entryPayload = values => ({
  customer_info: { full_name: values.full_name, phone: values.phone || '', email: values.email || '', address: values.address || '', company_name: values.company_name || '', source: values.source },
  interaction_details: { interaction_type: values.interaction_type, lead_stage: values.lead_stage, intent: values.intent, discussed_products: values.discussed_products || [], customer_mood: values.customer_mood, notes: values.notes },
  system_assignment: { assigned_agent_id: values.assigned_agent_id || null },
  action_plan: { next_action: values.next_action || '', follow_up_date: values.follow_up_date?.toISOString() || null },
});
export const optionLabel = value => String(value).replace(/_/g, ' ').toLowerCase().replace(/\b[a-z]/g, char => char.toUpperCase());
